"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const classnames_1 = __importDefault(require("classnames"));
const react_1 = __importDefault(require("react"));
const react_transition_group_1 = require("react-transition-group");
const Icon_1 = __importDefault(require("../../common/js/atoms/Icon"));
const LoadingSpinner_1 = __importDefault(require("../../common/js/components/LoadingSpinner"));
const Zupicons_1 = __importDefault(require("../../common/js/enums/Zupicons"));
const Transition_1 = __importDefault(require("../enums/Transition"));
const transition_1 = require("../helper/transition");
const ProductSuggestionDropdown_1 = __importDefault(require("./ProductSuggestionDropdown"));
const SearchInput = ({ disabled, onChange, onEnter, onClear, onFocus, onSuggestionClick, placeholder, value, suggestedProducts, showDropdown, setRef, isSuggestionLoading, className, }) => {
    const showClearButton = !!value && !disabled;
    const iconName = showClearButton ? Zupicons_1.default.close : Zupicons_1.default.search;
    const iconWrapperProps = showClearButton ? { onClick: () => onClear() } : {};
    const onKeyUp = (event) => {
        if (event.key === 'Enter' && onEnter) {
            onEnter(event);
        }
    };
    return (react_1.default.createElement("div", { className: (0, classnames_1.default)('znd-search-input', className), ref: setRef },
        react_1.default.createElement("input", { type: "text", className: "form-control znd-search-input__input", value: value, onChange: onChange, onKeyUp: onKeyUp, placeholder: placeholder, disabled: disabled, onFocus: onFocus }),
        react_1.default.createElement(ProductSuggestionDropdown_1.default, { showDropdown: showDropdown ?? false, suggestedProducts: suggestedProducts, onClick: onSuggestionClick }),
        react_1.default.createElement(react_transition_group_1.SwitchTransition, null,
            react_1.default.createElement(react_transition_group_1.CSSTransition, { key: iconName, addEndListener: transition_1.defaultEndListener, classNames: Transition_1.default.fade },
                react_1.default.createElement("div", { className: (0, classnames_1.default)('znd-search-input__icon', {
                        'znd-search-input__icon--clear': showClearButton,
                    }), ...iconWrapperProps },
                    react_1.default.createElement(Icon_1.default, { name: iconName }),
                    isSuggestionLoading ? (react_1.default.createElement(LoadingSpinner_1.default, { className: "znd-loading-spinner--small znd-loading-spinner--position-absolute" })) : null)))));
};
exports.default = SearchInput;
